module.exports = __webpack_public_path__ + "43d4efd90d9f30f038e4407c6bf4acab.jpg";